import { IHCPFlowKanbanColumn, IHCPFlowStatus } from './hcp-flow.interface'

function buildColumnFromStatus(
  status: IHCPFlowStatus,
  page: number,
  offset: number
): IHCPFlowKanbanColumn {
  return {
    statusId: status.id,
    flow: status.flow,
    flowCode: status.flowCode,
    sequence: status.sequence,
    displayCode: status.displayCode,
    name: status.name,
    isActive: status.isActive,
    sheetRule: status.sheetRule ?? null,
    page,
    offset,
    total: 0,
    hasNextPage: false,
    cards: [],
  }
}

/**
 * Fluxo 5: exibe todas as etapas cadastradas (inclusive vazias).
 * Agrupamento em card de pedido vem da API (type ORDER + groupedItems).
 */
export function applyLogisticsColumnLayout(
  columns: IHCPFlowKanbanColumn[],
  statuses: IHCPFlowStatus[],
  page: number,
  offset: number
): IHCPFlowKanbanColumn[] {
  const bySequence = new Map(columns.map((column) => [column.sequence, column]))

  statuses
    .filter((status) => status.isActive !== false)
    .forEach((status) => {
      if (!bySequence.has(status.sequence)) {
        bySequence.set(status.sequence, buildColumnFromStatus(status, page, offset))
      }
    })

  return Array.from(bySequence.values()).sort((a, b) => a.sequence - b.sequence)
}
